module.exports = __webpack_public_path__ + "img/shopping-basket.ea4f4653.svg";